import React, { useState } from 'react';
import './SettingReport.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';

const SettingsPage = () => {
    const { user } = useAuth();
    const username = user.user;

    const [formData, setFormData] = useState({
        username: username.username || "",
        role: username.role || "",
        phonenumber: username.mobile || "",
        emailId: username.email || "",
        report: "",
      });
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const handleSubmit = () => {
        // You can send the formData to your backend here
        axios
          .post(API_URL+'/submit', formData) // Define your backend URL and /submit endpoint
          .then((response) => {
            // Handle success
            console.log('Data sent successfully', response.data);
            window.alert('Report sent successfully')
            // Reset the form fields if needed
            setFormData({
              report: "",
            });
          })
          .catch((error) => {
            // Handle error
            console.error('Error sending data', error);
          });
      };

return( 
<div>
    <SideMenuBar></SideMenuBar>
    <div class="content">
        <NewHeader></NewHeader>
            
        <div className='row2'>
            <h3 className='settings_SettingsPage'>Settings</h3>  
        </div>

        <div className='row3_SettingReport'>
                <div className='heading_SettingReport'>
                    <Link to='/SettingsPage' className='a_of_heading'><p className='profile_SettingsPage'>&nbsp;Profile&nbsp;</p></Link>
                    <Link to='/SettingPswd' className='a_of_heading'><p className='password_SettingsPage'>&nbsp;Password&nbsp;</p></Link>
                    <Link to='/SettingReport' className='a_of_heading'><p className='report_SettingsPage'>&nbsp;Report&nbsp;</p></Link>
                </div>
    
            <div class="subrow2_row3_SettingReport">
                <div class="column1_subrow2_row3_SettingReport">
                    <p>Full Name</p>
                    <input className='input_subrow2_row3_SettingReport' placeholder='Enter Full Name' name='username'
                        value={formData.username}
                        onChange={handleInputChange}></input>
                    <p>Phone No.</p>
                    <input className='input_subrow2_row3_SettingReport' placeholder='Enter Phone No.' name='phonenumber'
                        value={formData.phonenumber}
                        onChange={handleInputChange}></input>
                    <p>Report</p>
                    <textarea className='reportProblem_input_subrow2_row3_SettingReport' placeholder='Report your Problem...' name='report'
                        value={formData.report}
                        onChange={handleInputChange}></textarea>
                 </div>
 
                 <div class="column2_subrow2_row3_SettingReport">
                    <p>Role</p>
                    <input className='input_subrow2_row3_SettingReport' placeholder='Enter Role' name='role'
                        value={formData.role}
                        onChange={handleInputChange}></input>
                    <p>Email ID</p>
                    <input className='input_subrow2_row3_SettingReport' placeholder='Enter Email ID' name='emailId'
                        value={formData.emailId}
                        onChange={handleInputChange}></input>
                </div>
            </div>
            <button className='send_btn_SettingReport' onClick={handleSubmit}>Send</button>
        </div>

        
        

    </div>
</div>
 )
}

export default SettingsPage;